import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-figma-benin-nav',
  templateUrl: './figma-benin-nav.component.html',
  styleUrls: ['./figma-benin-nav.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class FigmaBeninNavComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
